import { PostSection } from "@/components/blog/PostSection";
import { PostQuote } from "@/components/blog/PostQuote";

export function GeoSection() {
  return (
    <PostSection id="geo-optimizacion" title="GEO: Optimización para motores generativos">
      <p>
        Los AI Overviews son solo una parte de un cambio más amplio: la llegada de la 
        <strong> optimización para motores generativos</strong> o GEO (Generative Engine Optimization). 
        Este nuevo paradigma abarca no solo Google, sino también ChatGPT, Perplexity, Gemini y otros 
        asistentes de IA.
      </p>

      <h3 id="que-es-geo" className="text-xl font-bold text-white mt-8 mb-4">
        Qué es el GEO y por qué importa
      </h3>
      <p>
        El GEO es la disciplina de optimizar tu contenido para que sea <strong>seleccionado, citado 
        y recomendado</strong> por motores de búsqueda basados en IA. Mientras el SEO tradicional se 
        centra en rankings, el GEO se centra en <strong>citaciones</strong>.
      </p>
      <PostQuote 
        text="En 2026, triunfan quienes optimizan para lo que podemos llamar GEO — Generative Engine Optimization: contenido estructurado, claro, semántico, pensado para que un agente inteligente lo lea y lo cite."
        author="Tendencias SEO 2026"
      />
      <p className="mt-4">
        Los principios del GEO incluyen:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Claridad semántica:</strong> escribe para que una IA entienda el significado, no solo las keywords</li>
        <li><strong>Estructura lógica:</strong> bloques de información bien definidos y fácilmente extraíbles</li>
        <li><strong>Credibilidad verificable:</strong> datos con fuentes, experiencia demostrada, E-E-A-T real</li>
        <li><strong>Frescura:</strong> contenido actualizado regularmente con fechas visibles</li>
      </ul>

      <h3 id="geo-vs-seo" className="text-xl font-bold text-white mt-8 mb-4">
        GEO vs SEO tradicional: ¿competidores o complementarios?
      </h3>
      <p>
        No son excluyentes. El GEO <strong>se construye sobre los fundamentos del SEO</strong>: velocidad 
        de carga, optimización móvil, arquitectura de sitio y contenido de calidad siguen siendo la base. 
        El GEO añade una capa de optimización específica para ser la fuente preferida por los sistemas de IA.
      </p>
      <p className="mt-4">
        La estrategia ideal en 2026 combina <strong>SEO + GEO</strong>: posicionarte en resultados 
        tradicionales Y ser citado en respuestas de IA. Los mismos principios que te ayudan a aparecer 
        en AI Overviews también mejoran tu visibilidad en ChatGPT, Perplexity y otros buscadores de IA.
      </p>
    </PostSection>
  );
}
